import angular from 'angular';
import uiBootstrap from 'angular-ui-bootstrap';

export default angular.module('cms.page.content.guard', [uiBootstrap]).factory('ContentGuardService',
    function ($uibModal) {

        this.lockedElements = {};

        let registerLocked = (elementType) => {
            this.lockedElements[elementType] ? this.lockedElements[elementType]++ : this.lockedElements[elementType] = 1;
        };

        let checkIsLocked = (elementType, showInfo) => {
            let locked = this.lockedElements[elementType];
            if(locked && showInfo) {
                openDuplicatesModal()
            }
            return locked;
        };

        let deregisterLocked = (elementType) => {
            this.lockedElements[elementType]--;
        };


        let openDuplicatesModal = () => {
            return $uibModal.open({
                animation: true,
                template: require('./duplicated-section-info.html')
            }).result.then(() => {}, () => {});
        };

        return {
            registerLocked: registerLocked,
            deregisterLocked: deregisterLocked,
            checkIsLocked: checkIsLocked
        };


    }).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/Workspace/ContentGuard/ContentGuardService.js